import { create } from 'zustand';
import { meApi, type WorkspaceKey } from '../api';
import { WORKSPACE_BY_KEY } from '../components/layout/workspaces';
import { queryClient } from '../lib/queryClient';

interface WorkspaceState {
  /** Поточний робочий простір (null — ще не відомий або в людини немає просторів). */
  current: WorkspaceKey | null;
  /** З /auth/me (me.workspace) після входу чи перезавантаження. */
  init: (key: WorkspaceKey | null | undefined) => void;
  /**
   * Перемкнути простір: запамʼятати на сервері (prefs.workspace), перечитати дані простору і перейти на його головну.
   * silent — лише запамʼятати (людина сама перейшла посиланням у сторінку іншого свого простору).
   */
  setCurrent: (key: WorkspaceKey, opts?: { navigate?: (to: string) => void; silent?: boolean }) => Promise<void>;
}

export const useWorkspace = create<WorkspaceState>((set, get) => ({
  current: null,
  init: (key) => set({ current: key ?? null }),
  setCurrent: async (key, opts) => {
    if (get().current === key && opts?.silent) return;
    const prev = get().current;
    set({ current: key });
    if (!opts?.silent) opts?.navigate?.(WORKSPACE_BY_KEY[key]?.landing ?? '/');
    try {
      await meApi.putPrefs({ workspace: key });
      if (!opts?.silent) await queryClient.invalidateQueries({ queryKey: ['workspaces'] });
    } catch (e) {
      if (!opts?.silent) {
        set({ current: prev });
        throw e;
      }
    }
  },
}));
